import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`

  
  width:100%;
`;


export const AddUserButton = styled.button`


  color: ${theme.colors.dark};
  &:hover {
    opacity: 0.7;
  }
`;